import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CssTransition from "./css-transition";
import moment from "moment";
import { useSelector } from "react-redux";
import { socket } from "../../service/socket";

function DropdownNotifications({ align, notificationList, setNotificationList }) {
  const {type, email} = useSelector(state => state.auth);
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const trigger = useRef(null);
  const dropdown = useRef(null);

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
      setDropdownOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  const handleClickEvent = (data) => {
    setDropdownOpen(!dropdownOpen);
    const filterData = notificationList.filter((item) => item.id !== data.id);
    setNotificationList(filterData);

    const payload = {
      company_id: data.company_id,
      main_group_id: data.main_group_id,
      sub_group_id: data.id,
      email: email
    }
    socket.emit("mark_read_group_message", payload);

    if(!data.main_group_id){
      const statePayload = {
        id: data.id,
        main_group_id: data?.main_group_id,
        email: data.user_email,
        sub_group_id: data.sub_group_id,
        name: data.name,
        tab: data.tab,
      }
      navigate(`/chat`, { state: statePayload });
      return;
    }

    const statePayload = {
      id: data.id,
      main_group_id: data?.main_group_id,
      email: data.user_email,
      sub_group_id: data.id,
      name: data.name,
      tab: "chat",
    }

    navigate(`/todo/performance/${data.activity_assignment_id}`, { state: statePayload });

    // if(["collaborator", "customer"].includes(type)){
    //   navigate(`/todo/performance/${data.activity_assignment_id}`, {state: { tab: "chat" }});
    // }else{
    //   navigate(`/todo/performance/${data.activity_assignment_id}`, { state: })
    // }
  };

  return (
    <div className="relative inline-flex">
      <button ref={trigger} className={`w-8 h-8 flex items-center justify-center bg-slate-100 hover:bg-slate-200 transition duration-150 rounded-full ${dropdownOpen && "bg-slate-200"}`} aria-haspopup="true" onClick={() => setDropdownOpen(!dropdownOpen)} aria-expanded={dropdownOpen}>
        <span className="sr-only">Notifications</span>
        <span className="fas fa-bell fill-current"></span>
        {notificationList.length !== 0 && <div className="absolute top-0 -right-1 w-3 h-3 bg-rose-500 border-2 border-white rounded-full text-[10px] text-white font-semibold flex justify-center items-center"></div>}
      </button>

      <CssTransition className={`origin-top-right z-10 absolute top-full -mr-48 sm:mr-0 min-w-80 max-h-96 overflow-x-hidden overflow-y-auto no-scrollbar scroll-smooth bg-white border border-slate-200 py-1.5 rounded shadow-lg mt-1 ${align === "right" ? "right-0" : "left-0"}`} show={dropdownOpen} enter="transition ease-out duration-200 transform" enterStart="opacity-0 -translate-y-2" enterEnd="opacity-100 translate-y-0" leave="transition ease-out duration-200" leaveStart="opacity-100" leaveEnd="opacity-0">
        <div ref={dropdown} onFocus={() => setDropdownOpen(true)} onBlur={() => setDropdownOpen(false)}>
          <div className="text-xs font-semibold text-slate-400 uppercase pt-1.5 pb-2 px-4">Notifications</div>

          {notificationList.length === 0 ? (
            <div className="text-xs text-center font-semibold text-slate-500 py-3 px-4">No notification yet</div>
          ) : (
            <ul>
              {notificationList &&
                notificationList.map((item) => (
                  <li key={item.id} className="border-b border-slate-200 last:border-0 cursor-pointer">
                    <div
                      className="block py-2 px-4 hover:bg-slate-50"
                      // to="/chat"
                      // state={{
                      //   id: item.id,
                      //   main_group_id: item?.main_group_id,
                      //   email: item.user_email,
                      //   name: item.name,
                      //   tab: item.tab,
                      // }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClickEvent(item);
                      }}
                    >
                      <span className="block text-sm mb-2">
                        <div className="flex flex-row justify-between items-center">
                          <div>
                            📣 <span className="font-medium text-slate-800">{item.name}</span>
                          </div>
                          {item?.count && <div>
                            <div className="w-4 h-4 rounded-full flex justify-center items-center bg-green-600 text-[10px] text-white font-semibold">{item.count}</div>
                          </div> }
                        </div>
                        <p className="font-sm text-slate-600" style={{ whiteSpace: "pre-line" }}>
                          {item?.message}
                        </p>
                      </span>
                      <span className="block text-xs font-medium text-slate-400">{moment(item?.date).format("hh:mm a MMM DD, YYYY")}</span>
                    </div>
                  </li>
                ))}
              {/* <li className="border-b border-slate-200 last:border-0">
                <Link
                  className="block py-2 px-4 hover:bg-slate-50"
                  to="#0"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <span className="block text-sm mb-2">
                    📣{" "}
                    <span className="font-medium text-slate-800">
                      Edit your information in a swipe
                    </span>{" "}
                    Sint occaecat cupidatat non proident, sunt in culpa qui
                    officia deserunt mollit anim.
                  </span>
                  <span className="block text-xs font-medium text-slate-400">
                    Feb 12, 2021
                  </span>
                </Link>
              </li>
              <li className="border-b border-slate-200 last:border-0">
                <Link
                  className="block py-2 px-4 hover:bg-slate-50"
                  to="#0"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <span className="block text-sm mb-2">
                    📣{" "}
                    <span className="font-medium text-slate-800">
                      Edit your information in a swipe
                    </span>{" "}
                    Sint occaecat cupidatat non proident, sunt in culpa qui
                    officia deserunt mollit anim.
                  </span>
                  <span className="block text-xs font-medium text-slate-400">
                    Feb 9, 2021
                  </span>
                </Link>
              </li>
              <li className="border-b border-slate-200 last:border-0">
                <Link
                  className="block py-2 px-4 hover:bg-slate-50"
                  to="#0"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <span className="block text-sm mb-2">
                    🚀
                    <span className="font-medium text-slate-800">
                      Say goodbye to paper receipts!
                    </span>{" "}
                    Sint occaecat cupidatat non proident, sunt in culpa qui
                    officia deserunt mollit anim.
                  </span>
                  <span className="block text-xs font-medium text-slate-400">
                    Jan 24, 2020
                  </span>
                </Link>
              </li>
              <li className="border-b border-slate-200 last:border-0">
                <Link
                  className="block py-2 px-4 hover:bg-slate-50"
                  to="#0"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <span className="block text-sm mb-2">
                    🚀
                    <span className="font-medium text-slate-800">
                      Say goodbye to paper receipts!
                    </span>{" "}
                    Sint occaecat cupidatat non proident, sunt in culpa qui
                    officia deserunt mollit anim.
                  </span>
                  <span className="block text-xs font-medium text-slate-400">
                    Jan 24, 2020
                  </span>
                </Link>
              </li> */}
            </ul>
          )}

          {/* {notificationList.length !== 0 && (
            <ul>
              {notificationList.map((item, index) => (
                <li
                  key={index}
                  className="border-b border-slate-200 last:border-0"
                >
                  <Link
                    className="block py-2 px-4 hover:bg-slate-50"
                    to="/chat"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                  >
                    <span className="block text-sm mb-2">
                      📣{" "}
                      <span className="font-medium text-slate-800">
                        {item.name}
                      </span>{" "}
                      <p
                        className="font-sm text-slate-600"
                        style={{ whiteSpace: "pre-line" }}
                      >
                        {item.message}
                      </p>
                    </span>
                    <span className="block text-xs font-medium text-slate-400">
                      {/* Feb 12, 2021 *
                      {moment(item.date).format("MMM DD, YYYY")}
                    </span>
                  </Link>
                </li>
              ))}
              {/* <li className="border-b border-slate-200 last:border-0">
                <Link
                  className="block py-2 px-4 hover:bg-slate-50"
                  to="#0"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <span className="block text-sm mb-2">
                    📣{" "}
                    <span className="font-medium text-slate-800">
                      Edit your information in a swipe
                    </span>{" "}
                    Sint occaecat cupidatat non proident, sunt in culpa qui
                    officia deserunt mollit anim.
                  </span>
                  <span className="block text-xs font-medium text-slate-400">
                    Feb 12, 2021
                  </span>
                </Link>
              </li>
              <li className="border-b border-slate-200 last:border-0">
                <Link
                  className="block py-2 px-4 hover:bg-slate-50"
                  to="#0"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <span className="block text-sm mb-2">
                    📣{" "}
                    <span className="font-medium text-slate-800">
                      Edit your information in a swipe
                    </span>{" "}
                    Sint occaecat cupidatat non proident, sunt in culpa qui
                    officia deserunt mollit anim.
                  </span>
                  <span className="block text-xs font-medium text-slate-400">
                    Feb 9, 2021
                  </span>
                </Link>
              </li>
              <li className="border-b border-slate-200 last:border-0">
                <Link
                  className="block py-2 px-4 hover:bg-slate-50"
                  to="#0"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <span className="block text-sm mb-2">
                    🚀
                    <span className="font-medium text-slate-800">
                      Say goodbye to paper receipts!
                    </span>{" "}
                    Sint occaecat cupidatat non proident, sunt in culpa qui
                    officia deserunt mollit anim.
                  </span>
                  <span className="block text-xs font-medium text-slate-400">
                    Jan 24, 2020
                  </span>
                </Link>
              </li>
              <li className="border-b border-slate-200 last:border-0">
                <Link
                  className="block py-2 px-4 hover:bg-slate-50"
                  to="#0"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <span className="block text-sm mb-2">
                    🚀
                    <span className="font-medium text-slate-800">
                      Say goodbye to paper receipts!
                    </span>{" "}
                    Sint occaecat cupidatat non proident, sunt in culpa qui
                    officia deserunt mollit anim.
                  </span>
                  <span className="block text-xs font-medium text-slate-400">
                    Jan 24, 2020
                  </span>
                </Link>
              </li> 
            </ul>
          )} */}
        </div>
      </CssTransition>
    </div>
  );
}

export default DropdownNotifications;
